import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import { Task } from '../../../../shared/models/task';
import { IParentEntity } from 'app/shared/interfaces/entity';
import { enumTaskSelection, TaskService} from '../../../../shared/services/task.service';
import { ListFilterItem, ListSortOrderItem } from '../../../../shared/services/listSortAndFilterHelpers';

@Component({
    selector: 'fuse-task-list',
    templateUrl: './task-list.component.html',
    styleUrls: ['./task-list.component.scss'],
    animations: fuseAnimations,
})
export class FuseTaskListComponent implements OnInit, OnDestroy {
    tasks: Task[] = [];
    currentTask: Task;
    
    onTasksChanged: Subscription;
    onSelected: Subscription;
    onApplyFilter: Subscription;
    onApplySortOrder: Subscription;
    onApplySearchTerm: Subscription;
    sortOrder: ListSortOrderItem;
    filter: ListFilterItem;
    searchTerm: string;
    onSubjectDashboard = false;
        
    _parent: IParentEntity;

    @Input() taskSelection: enumTaskSelection = enumTaskSelection.AllTasks;

    @Input() inWidget: boolean;
    @Input() readOnly = false;

    @Input() set parent(val: IParentEntity){        
        if (val && val.type){            
            this._parent = val;      
            this.onSubjectDashboard = true;
            this.taskService.setTaskSelection(enumTaskSelection.SubjectTasks, null, this._parent.uid);      
            this.taskService.getTasks();            
        }
    }

    constructor(public taskService: TaskService) {                
        this.filter = this.taskService.getFilters().find((filter) => filter.selected);
        this.sortOrder = this.taskService.getSortOrders().find((sortOrder) => sortOrder.selected);
        this.searchTerm = '';
    }

    ngOnInit() { 
        this.onApplySearchTerm =  this.taskService.onApplySearchTerm.pipe(
            debounceTime(150), distinctUntilChanged())
            .subscribe( (searchTerm: string) => {            
            this.searchTerm = searchTerm;            
            this.taskService.getTasks();
        });

        this.onApplySortOrder = this.taskService.onApplySortOrder.subscribe( (sortOrder: ListSortOrderItem) => {
            this.taskService.getSortOrders().forEach((s) => s.selected = false );
            if (this.sortOrder && sortOrder)
            {
                if (this.sortOrder.title === sortOrder.title)
                {
                    sortOrder.order = this.sortOrder.order * -1;
                }
            }
            this.sortOrder = sortOrder;
            this.sortOrder.selected = true;            
            this.taskService.getTasks();
        });

        this.onApplyFilter = this.taskService.onApplyFilter.subscribe((filter: ListFilterItem) => {             
            this.taskService.getFilters().forEach((f) => f.selected = false );
            this.filter = filter;
            this.filter.selected = true;
            this.taskService.getTasks();
        });

        this.onTasksChanged = this.taskService.onChanged.subscribe((tasks: Task[]) => {
            let taskList: Task[] = tasks;
            if (tasks && (tasks.length > 0)){
                taskList = this.taskService.applyFilter(taskList, this.filter);
                taskList = this.taskService.applySortOrder(taskList, this.sortOrder);                        
                if (this.searchTerm && this.searchTerm.length > 3 )
                {
                    taskList = this.taskService.applySearchTerm(taskList, this.searchTerm);                                    
                }
                if (!this.inWidget){
                    taskList = taskList.filter((i) => !(i.subject && i.subject.archived));
                }
                taskList.map((t) => t.readOnly = (t.readOnly || this.readOnly));
            }
            this.tasks = [...taskList];
            this.taskService.onSelected.next(null);
        });

        this.onSelected = this.taskService.onSelected.subscribe((currentTask: Task) => {
            
            if (!currentTask) {
                this.currentTask = null;
            }
            else {                
                this.currentTask = currentTask;
            }
        });
    }

    ngOnDestroy() {
        this.onTasksChanged?.unsubscribe();
        this.onSelected?.unsubscribe();        
        this.onApplyFilter?.unsubscribe();
        this.onApplySortOrder?.unsubscribe();
        this.onApplySearchTerm?.unsubscribe();
        // push an empty array - this ensures that subsequent components are not picking up/processing tasks from this list
        this.taskService.onChanged.next([]);
    }

    selectTask(task: Task) {        
        this.taskService.onSelected.next(task);        
    }

    editTask(task: Task){
        event.stopPropagation();
        this.selectTask(task);
        // if (this.onSubjectDashboard){
        this.taskService.onNewTaskClicked.next(task);
        // }
    }

    trackByFn(index, item){
        return item.id;
    }
}
